import React from 'react';
import {Route} from 'react-router-dom';
import {PartnerPage} from '../../partners/PartnerPage';
import {DashboardNavigationTopBar} from '../dashboard/DashboardNavigationTopBar';
import css from './PartnerNavigation.module.css';

export const PARTNER_ROUTES_PREFIX = '/partner';
export const PARTNER_ROUTES = {
  PARTNER_PAGE: `${PARTNER_ROUTES_PREFIX}/:slug`,
};

export const PartnerNavigation = () => {
  return (
    <div className={css.navigationWrapper}>
      <DashboardNavigationTopBar isPublic />

      <Route
        path={PARTNER_ROUTES.PARTNER_PAGE}
        exact={true}
        component={PartnerPage}
      />
    </div>
  );
};
